import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const FacebookFlatIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                stroke="none"
                d="M 6.555625 3.590396 L 5.34475 3.590396 L 5.34475 2.760092 C 5.34475 2.448271 5.542417 2.375575 5.681625 2.375575 C 5.820542 2.375575 6.536167 2.375575 6.536167 2.375575 L 6.536167 1.004763 L 5.359292 0.999958 C 4.052904 0.999958 3.755604 2.022358 3.755604 2.676629 L 3.755604 3.590396 L 3.000083 3.590396 L 3.000083 5.002958 L 3.755604 5.002958 C 3.755604 6.81575 3.755604 8.999958 3.755604 8.999958 L 5.34475 8.999958 C 5.34475 8.999958 5.34475 6.794209 5.34475 5.002958 L 6.417042 5.002958 L 6.555625 3.590396 Z"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const FacebookFlatIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                stroke="none"
                d="M 6.555625 3.590396 L 5.34475 3.590396 L 5.34475 2.760092 C 5.34475 2.448271 5.542417 2.375575 5.681625 2.375575 C 5.820542 2.375575 6.536167 2.375575 6.536167 2.375575 L 6.536167 1.004763 L 5.359292 0.999958 C 4.052904 0.999958 3.755604 2.022358 3.755604 2.676629 L 3.755604 3.590396 L 3.000083 3.590396 L 3.000083 5.002958 L 3.755604 5.002958 C 3.755604 6.81575 3.755604 8.999958 3.755604 8.999958 L 5.34475 8.999958 C 5.34475 8.999958 5.34475 6.794209 5.34475 5.002958 L 6.417042 5.002958 L 6.555625 3.590396 Z"
            />
        </SvgIcon>
    );
};
